"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", {
  transform: "translate(6 5)"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M16.94,15a4,4,0,1,1,4-4A4,4,0,0,1,16.94,15Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,16.94,8Z"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "16.94",
  cy: "11.02",
  r: "1.53"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M5.06,8.67a4,4,0,1,1,4-4A4,4,0,0,1,5.06,8.67Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,5.06,1.67Z"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "5.06",
  cy: "4.67",
  r: "1.53"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M5.06,21.33a4,4,0,1,1,4-4A4,4,0,0,1,5.06,21.33Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,5.06,14.33Z"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "5.06",
  cy: "17.33",
  r: "1.53"
}), /*#__PURE__*/_react["default"].createElement("rect", {
  x: "7.77",
  y: "13.67",
  width: "6.45",
  height: "1",
  transform: "translate(-5.38 6.85) rotate(-28.12)"
}), /*#__PURE__*/_react["default"].createElement("rect", {
  x: "10.51",
  y: "4.58",
  width: "1",
  height: "6.47",
  transform: "translate(-1.07 13.85) rotate(-61.88)"
})));
module.exports = exports.default;